// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  initialAdministrationValues,
  initialLossValues,
  initialRadioValues,
  initialRegulatoryValues,
  makeInitialAntennaValues,
  makeInitialSiteValues,
} from 'redux/modules/pathDetails'

const makeBulkUpdateSiteModeInitialValues = () => (dispatch, getState) => {
  const unitType = getState().projectSummary.get('unitType')

  const administration = [{
    ...initialAdministrationValues,
    // the Path Details default value for segmentStatusId is '3' for E status.
    // HOWEVER, for Bulk Edit, we need to default this value as blank
    // otherwise we would always set status to E on update.
    segmentStatusId: '',
  }]

  // NOTE - although in bulk edits there can only be one antenna,
  // we must create a 2d array of antennas so we can reuse the
  // Path Details logic for handling antennas.
  const antennas = [[makeInitialAntennaValues(unitType)]]
  const losses = [{ ...initialLossValues }]
  const radios = [{ ...initialRadioValues }]

  // null, null means that we're not giving
  // contact/company defaults for bulk editing.
  const sites = [makeInitialSiteValues(unitType, null, null)]

  // Path Details has some default regulatory values which
  // we do not want on Bulk Edits. Takes what's needed and clears the rest.
  const regulatory = [{ ...initialRegulatoryValues }]
  regulatory[0].licenseBasisId = ''
  regulatory[0].stationClassId = ''
  regulatory[0].radioServiceId = ''

  // this will be linked with a checkbox that is not visible on the Path Details form.
  // this checkbox will allow the user to say 'I want to apply a digitized ground elevation
  // to all the sites I have selected', in place of assigning a single ground elevation
  // for all the sites that are selected.
  const setGroundElevations = []

  return {
    administration,
    antennas,
    losses,
    radios,
    regulatory,
    setGroundElevations,
    sites,
    unitType,
  }
}

export default makeBulkUpdateSiteModeInitialValues
